import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { RootState } from '@/store';
import { Grid } from '@/models/Grid.model';
import { InsurersReportModel } from '@/models/backoffice/InsurersReportModel';

Vue.use(Vuex);

export interface InsurersReportsState {
  insurersReportsErrors: string[];
  insurersReportsLoading: boolean;
  insurersReportsList: Grid<InsurersReportModel>;
}

export const initialState = (): InsurersReportsState => {
  return {
    insurersReportsErrors: [],
    insurersReportsLoading: false,
    insurersReportsList: {} as Grid<InsurersReportModel>,
  };
};

export const insurersReports: Module<InsurersReportsState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
